import { HttpClient } from '@/shared/lib/http-client';

export const createResourceRequest = async(payload) => {
  const response = await HttpClient.post('/resource-requests', payload);

  return response.data?.data;
};

export const unsubscribeFromResources = async(id, token) => {
  const response = await HttpClient.post(`/resources/unsubscribe/${id}`, { token });

  return response.data?.data;
};
